/* tslint:disable */
/* eslint-disable */
export enum IntensityBucketEnum {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH'
}
